
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function Language() {
  const navigate = useNavigate();
  
  const selectLanguage = (lang: string) => {
    localStorage.setItem('selectedLanguage', lang);
    navigate('/auth');
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-pink-50 flex flex-col items-center justify-center px-6">
      <div className="text-center mb-12">
        <div className="w-24 h-24 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mb-6 mx-auto shadow-lg">
          <i className="ri-global-line text-3xl text-white"></i>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-800 mb-2">اختر لغتك المفضلة</h1>
        <p className="text-gray-600">Choose Your Preferred Language</p>
      </div>
      
      <div className="w-full max-w-sm space-y-4">
        <Button
          variant="primary"
          size="lg"
          fullWidth
          onClick={() => selectLanguage('ar')}
          className="text-xl py-6"
        >
          <div className="flex items-center justify-center space-x-3">
            <span className="text-2xl">🇸🇦</span>
            <span>العربية</span>
          </div>
        </Button>
        
        <Button
          variant="outline"
          size="lg"
          fullWidth
          onClick={() => selectLanguage('en')}
          className="text-xl py-6"
        >
          <div className="flex items-center justify-center space-x-3">
            <span className="text-2xl">🇺🇸</span>
            <span>English</span>
          </div>
        </Button>
      </div>
      
      <div className="mt-12 text-center">
        <p className="text-sm text-gray-500">
          يمكنك تغيير اللغة لاحقاً من الإعدادات
        </p>
        <p className="text-sm text-gray-500">
          You can change language later in settings
        </p>
      </div>
    </div>
  );
}
